export const getParamFromUrl = (paramName: string) =>
  new URL(window.location.href).searchParams.get(paramName);

export const isMagicLink = (email: string): boolean =>
  /^share-.*@dealbinder.com$/.test(email);
